import { render, staticRenderFns } from "./addiction.vue?vue&type=template&id=30a7a35c&scoped=true&"
import script from "./addiction.vue?vue&type=script&lang=ts&"
export * from "./addiction.vue?vue&type=script&lang=ts&"
import style0 from "./addiction.vue?vue&type=style&index=0&id=30a7a35c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a7a35c",
  null
  
)

export default component.exports